import {selector, useRecoilValueLoadable} from 'recoil';
import {getBootstrapVersion} from 'webapp-lib/utils';

const FRONTEND_VERSION_PATH = '/version.json';
const BACKEND_VERSION_PATH = `${
  process.env.REACT_APP_SERVER_URL || '/api'
}/version`;

export type Version = {
  frontend?: string;
  backend?: string;
  browser?: string;
};

const fetchVersionInfo = async (): Promise<Version> => {
  let frontendVersion;
  let backendVersion;
  let browserVersion;

  try {
    const responseFrontend = await fetch(FRONTEND_VERSION_PATH);
    const bodyFrontend = await responseFrontend.json();
    frontendVersion = bodyFrontend.version;
  } catch {
    frontendVersion = 'local';
  }
  try {
    const responseBackend = await fetch(BACKEND_VERSION_PATH);
    const bodyBackend = await responseBackend.json();
    backendVersion = bodyBackend.version;
  } catch {
    backendVersion = 'local-backend';
  }
  try {
    browserVersion = await getBootstrapVersion();
  } catch {
    browserVersion = 'local';
  }

  return {
    frontend: frontendVersion,
    backend: backendVersion,
    browser: browserVersion,
  };
};

const versionSelector = selector({
  key: 'version',
  get: fetchVersionInfo,
});

export const useVersionInfo = (): Version => {
  const {state, contents} = useRecoilValueLoadable(versionSelector);
  switch (state) {
    case 'hasValue':
      return contents;
    default:
      return {};
  }
};
